export class RegistrationWithPlatformMember {
    registration;
    member;
    constructor(options) {
        this.registration = options.registration;
        this.member = options.member;
    }
    clone() {
        return new RegistrationWithPlatformMember({
            registration: this.registration.clone(),
            member: this.member, // no need to clone because it is a reference
        });
    }
    // Convenience helpers
    get group() {
        return this.registration.group;
    }
}
//# sourceMappingURL=RegistrationWithPlatformMember.js.map